var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalEvent01 = function SvgCalEvent01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.12,
    y1: 193.48,
    x2: 187.99,
    y2: 29.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 24.99,
    y1: 220.66,
    x2: 211.85,
    y2: 56.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 29.02,
    y1: 225.25,
    x2: 215.88,
    y2: 61.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -18.55,
    y1: 171.08,
    x2: 168.32,
    y2: 7.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -16.53,
    y1: 173.38,
    x2: 170.33,
    y2: 9.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.02,
    y1: 189.9,
    x2: 184.84,
    y2: 25.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0,
    y1: 192.2,
    x2: 186.86,
    y2: 28.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 14.51,
    y1: 208.73,
    x2: 201.37,
    y2: 44.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 12.66,
    y1: 206.63,
    x2: 199.53,
    y2: 42.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 41.51,
    y1: 239.48,
    x2: 228.38,
    y2: 75.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 58.04,
    y1: 258.31,
    x2: 244.91,
    y2: 94.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 43.53,
    y1: 241.78,
    x2: 230.39,
    y2: 77.7,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M183.33,13.33h-20v-3.33c0-5.52-4.48-10-10-10s-10,4.48-10,10v3.33h-33.33v-3.33c0-5.52-4.48-10-10-10s-10,4.48-10,10v3.33h-33.33v-3.33c0-5.52-4.48-10-10-10s-10,4.48-10,10v3.33h-20C7.47,13.34.01,20.8,0,30v153.33c.01,9.2,7.47,16.66,16.67,16.67h166.67c9.2-.01,16.66-7.47,16.67-16.67V30c-.01-9.2-7.47-16.66-16.67-16.67ZM150,10c0-1.84,1.49-3.33,3.33-3.33s3.33,1.49,3.33,3.33v20c0,1.84-1.49,3.33-3.33,3.33s-3.33-1.49-3.33-3.33V10ZM96.67,10c0-1.84,1.49-3.33,3.33-3.33s3.33,1.49,3.33,3.33v20c0,1.84-1.49,3.33-3.33,3.33s-3.33-1.49-3.33-3.33V10ZM43.33,10c0-1.84,1.49-3.33,3.33-3.33s3.33,1.49,3.33,3.33v20c0,1.84-1.49,3.33-3.33,3.33s-3.33-1.49-3.33-3.33V10ZM193.33,183.33c0,5.52-4.48,9.99-10,10H16.67c-5.52,0-9.99-4.48-10-10V60h186.67v123.33ZM193.33,53.33H6.67v-23.33c0-5.52,4.48-9.99,10-10h20v10c0,5.52,4.48,10,10,10s10-4.48,10-10v-10h33.33v10c0,5.52,4.48,10,10,10s10-4.48,10-10v-10h33.33v10c0,5.52,4.48,10,10,10s10-4.48,10-10v-10h20c5.52,0,9.99,4.48,10,10v23.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.33,103.33h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM166.67,90h6.67v6.67h-6.67v-6.67Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110,150h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33ZM106.67,163.33h-6.67v-6.67h6.67v6.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.33,103.33h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM66.67,90h6.67v6.67h-6.67v-6.67Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M30,136.67h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM33.33,123.33h6.67v6.67h-6.67v-6.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M63.33,136.67h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM66.67,123.33h6.67v6.67h-6.67v-6.67Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30,170h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM33.33,156.67h6.67v6.67h-6.67v-6.67Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63.33,170h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM66.67,156.67h6.67v6.67h-6.67v-6.67Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M103.11,115.16l-2.88,17.64c-.29,1.82.94,3.53,2.76,3.82.73.12,1.49-.01,2.14-.37l14.87-8.22,14.87,8.22c1.61.89,3.64.31,4.53-1.3.36-.65.49-1.41.37-2.15l-2.87-17.64,12.16-12.46c1.29-1.32,1.26-3.43-.05-4.71-.5-.49-1.14-.81-1.83-.91h0s-16.67-2.54-16.67-2.54l-7.49-15.95c-.78-1.67-2.77-2.38-4.43-1.6-.7.33-1.27.9-1.6,1.6l-7.48,15.95-16.67,2.55c-1.82.28-3.07,1.98-2.79,3.8.1.69.42,1.33.91,1.83l12.16,12.46ZM112.26,100.85c1.1-.17,2.04-.87,2.51-1.88l5.22-11.13,5.22,11.13c.47,1.01,1.42,1.71,2.51,1.88l12.01,1.83-8.8,9.02c-.74.76-1.07,1.82-.9,2.86l2.04,12.52-10.47-5.79c-1-.55-2.22-.55-3.23,0l-10.47,5.79,2.04-12.52c.17-1.04-.17-2.11-.9-2.86l-8.8-9.02,12.01-1.83Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M163.33,136.67h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM166.67,123.33h6.67v6.67h-6.67v-6.67Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M163.33,170h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33ZM166.67,156.67h6.67v6.67h-6.67v-6.67Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.33,150h-13.33c-1.84,0-3.33,1.49-3.33,3.33v13.33c0,1.84,1.49,3.33,3.33,3.33h13.33c1.84,0,3.33-1.49,3.33-3.33v-13.33c0-1.84-1.49-3.33-3.33-3.33ZM140,163.33h-6.67v-6.67h6.67v6.67Z"
  })));
};
export default SvgCalEvent01;